import { ActionTypeEnum } from 'redux/ActionTypeEnum';

//
const provincesActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.provinces_request,
	payload,
	meta,
});

const provincesActionSuccess = (payload) => ({
	type: ActionTypeEnum.province_success,
	payload,
});

// single filter
const filteredCitiesAction = (payload) => ({
	type: ActionTypeEnum.filtered_cities_action,
	payload,
});

export { provincesActionRequest, provincesActionSuccess, filteredCitiesAction };
